import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignRight: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="layout-align-right">
      <path
        d="M4 4L4 3H3V4L4 4ZM20 4L21 4V3H20V4ZM20 20V21H21L21 20H20ZM4 20H3V21H4V20ZM15 16V17H17V16H15ZM17 8V7H15V8H17ZM4 5L20 5V3L4 3L4 5ZM19 4L19 20H21V4L19 4ZM20 19H4V21H20V19ZM5 20L5 4L3 4L3 20H5ZM17 16V8H15V16H17Z"
        fill="currentColor"
      />
    </CentralIconBase>
  );
};

export default IconLayoutAlignRight;
